import { render, staticRenderFns } from "./CoachAside.vue?vue&type=template&id=7a095fbe"
import script from "./CoachAside.vue?vue&type=script&lang=js"
export * from "./CoachAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports